export default function handleKeydownEvents ( store, event )
{
    const target = event.target;

    if ( store.getters.isMobile )
    {

        // tab
        if ( event.which === 9 )
        {

            // shift-tab (left)
            if ( event.shiftKey )
            {
                // coming from the grid/list buttons
                if ( isSortOrderOption( target ) )
                {
/*console.log(( 'SHIFT_TAB: isSortOrderOption' ))*/;                    findAndMaybeFocus( '.filter-toggle-mobile' );

                } else if ( isMobileFiltersToggler( target ) )
                {
/*console.log(( 'SHIFT_TAB: isMobileFiltersToggler' ))*/;                    findAndMaybeFocus( '#list-mode-layout_list' );
                } else if ( isKeywordFilter( target ) )
                {
/*console.log(( 'SHIFT_TAB: isKeywordFilter' ))*/;                    findAndMaybeFocus( '#list-mode-order' );
                }


            } else
            {
                // tab

                if ( isLayoutOption( target ) )
                {
/*console.log(( 'TAB: isLayoutOption' ))*/;                    findAndMaybeFocus( '.filter-toggle-mobile' );
                } else if ( isMobileFiltersToggler( target ) )
                {
/*console.log(( 'TAB: isMobileFiltersToggler' ))*/;                    findAndMaybeFocus( '#list-mode-order' );
                } else if ( isSortOrderOption( target ) )
                {

                    const maybeFilter = document.querySelector( '#main .search-results .results-section .keywords-list .keyword-filter-button' );

/*console.log(( 'TAB: isSortOrderOption', maybeFilter ))*/;                    if ( maybeFilter )
                    {
                        event.preventDefault();
                        maybeFilter.focus();
                        return false;
                    }


                    const resultsTop = document.querySelector( '.search-results .results-info .num-results' );
                    if ( resultsTop )
                    {
                        resultsTop.focus();
                        return false;
                    }


                    // else
                    findAndMaybeFocus( '.results a' );

                }
            }
        }

    }


    function findAndMaybeFocus ( selector )
    {
        const element = document.querySelector( selector );

        if ( element )
        {
            event.preventDefault();
/*console.log(( 'trying to focus on', element ))*/;            element.focus();
        }

        return false;
    }


    function isMobileFiltersToggler ( element )
    {
        if ( !element )
        {
            return false;
        }

        return element.classList.contains( 'filter-toggle-mobile' );
    }

    function isLayoutOption ( element )
    {

        if ( !element )
        {
            return false;
        }

        const id = element.getAttribute( 'id' );
        return id && id.includes( 'list-mode-layout' );
    }

    function isSortOrderOption ( element )
    {
        if ( !element )
        {
            return false;
        }

        const id = element.getAttribute( 'id' );
        return id === 'list-mode-order';
    }

    function isKeywordFilter ( element )
    {
        if ( !element )
        {
            return false;
        }

        return element.classList.contains( 'keyword-filter-button' );
    }

    function isBtnJumpToResults ( element )
    {
        const id = element.getAttribute( 'id' );
        return id === 'btn-jump-to-results';
    }
}
